import { makeAutoObservable, reaction } from 'mobx'

const THEME_STORAGE_KEY = 'themeMode'

class ThemeStore {
  mode = 'light' // 'light' or 'dark'

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })

    // 1. При инициализации пытаемся загрузить тему из localStorage
    try {
      const savedTheme = localStorage.getItem(THEME_STORAGE_KEY)
      if (savedTheme === 'light' || savedTheme === 'dark') {
        this.mode = savedTheme
      } else {
        // Если в хранилище ничего нет, используем системные настройки
        const prefersDark =
          window.matchMedia &&
          window.matchMedia('(prefers-color-scheme: dark)').matches
        this.mode = prefersDark ? 'dark' : 'light'
      }
    } catch (error) {
      console.error('Не удалось получить доступ к localStorage', error)
    }

    // 2. Создаем реакцию, которая будет сохранять изменения темы в localStorage
    reaction(
      () => this.mode,
      (mode) => {
        try {
          localStorage.setItem(THEME_STORAGE_KEY, mode)
        } catch (error) {
          console.error('Не удалось сохранить тему в localStorage', error)
        }
      },
    )
  }

  toggleTheme() {
    this.mode = this.mode === 'light' ? 'dark' : 'light'
  }
}

export default ThemeStore
